import {
	IGetDishInfo,
	IGetDishInfoV2,
	IGetDishesShort,
	IGetDishesShortByRestaurantId,
	IGetDishesShortBySubCategoryIdsArguments,
	IGetDishesShortArgs,
	IGetDishesByRestaurantIdsAndSubcategoryIdsArgs,
	IGetDishesByRestaurantIdsAndSubcategoryIds,
	ICreateDish,
	ICreateDishV2,
	IUpdateDish,
	IUpdateDishV2,
	IGetPaginatedDishes,
	IGetPaginatedDishesByCustomerV2,
	IDishesByCustomerV2,
	IGetPaginatedDishesByRestaurantV2,
	IDishesByRestaurantV2,
	IDishes,
	IGetDishPositionListArguments,
	IGetDishPositionListArgumentsV2,
	IGetDishPositionList,
	IGetDishPositionListV2,
	IGetDishPositionChainsArguments,
	IGetDishPositionChainsArgumentsV2,
	IGetDishPositionChains,
	IUpdateDishPositions,
	IUpdateDishPositionsV2,
	IGetDishRestaurantPropertiesArguments,
	IGetDishRestaurantProperties,
	IUpdateDishRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForDish,
	IGetPaginatedDishesForAssign,
	IDishesForAssign,
	IGetListRestaurantsForAssignDishesArguments,
	IGetListRestaurantsForAssignDishes,
	IGetCategoriesByIDRestaurantForAssignDishes,
	IGetSubcategoriesByIDsCategoriesArguments,
	IGetSubcategoriesByIDsCategoriesForAssignDishes,
	IGetDishesByIDsSubcategoriesArguments,
	IGetDishesByIDsSubcategoriesForAssignDishes,
	IAssignDish,
	IAssignDishToSubcategories,
	IAssignDishToSubcategoriesValidate,
	IGetDishPortionInfo,
	ICreatePortion,
	IGetDishRestaurantPortions,
	IGetDishRestaurantPortionsArguments,
	IToggleDishPortionsEnabledArguments,
	IDeleteDishPortionArguments,
	IUpdatePortion,
	IGetPortionPositionListArguments,
	IGetPortionPositionList,
	IGetPortionPositionChains,
	IUpdatePortionPositions,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

// Menu v1
const serviceGetDishInfo = (dishID: string): Promise<IGetDishInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Dishes/${dishID}` });
};
// Menu v1
// Menu v2
const serviceGetDishInfoV2 = (dishID: string): Promise<IGetDishInfoV2> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/dishes/${dishID}` });
};
// Menu v2

// Menu v1
const serviceGetDishesShortBySubCategoryId = (subCategoryId: string): Promise<IGetDishesShort> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/Dishes/shortBySubCategoryId?subCategoryId=${subCategoryId}`,
	});
};
// Menu v1
// Menu v2
const serviceGetDishesShortBySubCategoryIdV2 = (subCategoryId: string): Promise<IGetDishesShort> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/subCategories/${subCategoryId}/dishes` });
};
// Menu v2

const serviceGetDishesShortBySubCategoryIds = (
	args: IGetDishesShortBySubCategoryIdsArguments,
): Promise<IGetDishesShort> => {
	return request({ typeOfRequest: 'postWithToken', url: '/api/Dishes/shortBySubCategoryIds', data: args });
};

const serviceGetDishesShortByCustomerId = ({
	customerId,
	isCombo = false,
}: IGetDishesShortArgs): Promise<IGetDishesShort> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/Dishes/shortByCustomerId?customerId=${customerId}&IsCombo=${isCombo}`,
	});
};

const serviceGetDishesShortByRestaurantId = (restaurantId: string): Promise<IGetDishesShortByRestaurantId> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/restaurants/${restaurantId}/restaurant-dishes` });
};

const serviceGetDishesByRestaurantIdsAndSubcategoryIds = ({
	restaurantIds,
	subCategoryIds,
}: IGetDishesByRestaurantIdsAndSubcategoryIdsArgs): Promise<IGetDishesByRestaurantIdsAndSubcategoryIds> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: '/api/ModifierGroups/dishes',
		data: { restaurantIds, subCategoryIds },
	});
};

// Menu v1
const serviceCreateDish = (data: ICreateDish): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Dishes`, data });
};
// Menu v1
// Menu v2
const serviceCreateDishV2 = (data: ICreateDishV2): Promise<AxiosResponse<{ id: string }>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/dishes`, data });
};
// Menu v2

// Menu v1
const serviceUpdateDish = (data: IUpdateDish): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Dishes/${data.id}`, data });
};
// Menu v1
// Menu v2
const serviceUpdateDishV2 = (data: IUpdateDishV2): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/dishes/${data.id}`, data });
};
// Menu v2

// Menu v1
const serviceGetPaginatedDishes = (args: IGetPaginatedDishes): Promise<AxiosResponse<IDishes>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Dishes/filtered`, data: args });
};
// Menu v1
// Menu v2
const serviceGetPaginatedDishesByCustomerV2 = (
	args: IGetPaginatedDishesByCustomerV2,
): Promise<AxiosResponse<IDishesByCustomerV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/dishes:search`, data: args });
};

const serviceGetPaginatedDishesByRestaurantV2 = (
	args: IGetPaginatedDishesByRestaurantV2,
): Promise<AxiosResponse<IDishesByRestaurantV2>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/restaurant-dishes:search`, data: args });
};
// Menu v2

// Menu v1
const serviceDeleteDish = (dishID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Dishes/${dishID}` });
};
// Menu v1
// Menu v2
const serviceDeleteDishV2 = (dishID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/v2/dishes/${dishID}` });
};
// Menu v2

// Menu v1
const serviceGetDishPositionList = (args: IGetDishPositionListArguments): Promise<IGetDishPositionList> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Dishes/positionList`, data: args });
};
// Menu v1
// Menu v2
const serviceGetDishPositionListV2 = (args: IGetDishPositionListArgumentsV2): Promise<IGetDishPositionListV2> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/dishes?subCategoryId=${args.subCategoryId}`,
	});
};
// Menu v2

// Menu v1
const serviceGetDishPositionsChains = (args: IGetDishPositionChainsArguments): Promise<IGetDishPositionChains> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Dishes/positions`, data: args });
};
// Menu v1
// Menu v2
const serviceGetDishPositionsChainsV2 = (
	args: IGetDishPositionChainsArgumentsV2,
): Promise<IGetListRestaurantsForAssignDishes> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/same-dish-set/${args.subCategoryId}`,
	});
};
// Menu v2

// Menu v1
const serviceUpdateDishPositions = (data: IUpdateDishPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Dishes/changePositions`, data });
};
// Menu v1
// Menu v2
const serviceUpdateDishPositionsV2 = (data: IUpdateDishPositionsV2): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/dishes:change-positions`, data });
};
// Menu v2

const serviceGetDishRestaurantProperties = (
	args: IGetDishRestaurantPropertiesArguments,
): Promise<IGetDishRestaurantProperties> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/restaurant-dishes/${args.dishId}`,
	});
};

const serviceUpdateDishRestaurantProperties = (data: IUpdateDishRestaurantProperties): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'putWithToken',
		url: `/api/v2/restaurants/${data.restaurantId}/restaurant-dishes/${data.dishId}`,
		data,
	});
};

const serviceUpdateDishRestaurantPropertiesAsPatch = (
	data: IUpdateRestaurantPropertiesAsPatchForDish,
): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/restaurant-dishes/${data.dishId}`, data });
};

// Menu v1
const serviceGetPaginatedDishesForAssign = (
	args: IGetPaginatedDishesForAssign,
): Promise<AxiosResponse<IDishesForAssign>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Dishes/assignFiltered`, data: args });
};
// Menu v1
// Menu v2
const serviceGetPaginatedDishesForAssignV2 = (
	args: IGetPaginatedDishesForAssign,
): Promise<AxiosResponse<IDishesForAssign>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/dishes:assign-filtered`, data: args });
};
// Menu v2

// Menu v1
const serviceGetListRestaurantsForAssignDishes = (
	args: IGetListRestaurantsForAssignDishesArguments,
): Promise<IGetListRestaurantsForAssignDishes> => {
	const dataForRequest = {
		subCategoryIds: args.subCategoryIds,
		dishIds: args.dishIds,
	};
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/AssignDishes/customers/${args.customerId}/restaurants`,
		data: dataForRequest,
	});
};
// Menu v1
// Menu v2
const serviceGetListRestaurantsForAssignDishesV2 = (
	args: IGetListRestaurantsForAssignDishesArguments,
): Promise<IGetListRestaurantsForAssignDishes> => {
	const dataForRequest = {
		subCategoryIds: args.subCategoryIds,
		dishIds: args.dishIds,
	};
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v2/assign-dishes/customers/${args.customerId}/restaurants`,
		data: dataForRequest,
	});
};
// Menu v2

// Menu v1
const serviceGetCategoriesByIDRestaurantForAssignDishes = (
	restaurantId: string,
): Promise<IGetCategoriesByIDRestaurantForAssignDishes> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/AssignDishes/restaurants/${restaurantId}/categories` });
};
// Menu v1
// Menu v2
const serviceGetCategoriesByIDRestaurantForAssignDishesV2 = (
	restaurantId: string,
): Promise<IGetCategoriesByIDRestaurantForAssignDishes> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/assign-dishes/restaurants/${restaurantId}/categories`,
	});
};
// Menu v2

// Menu v1
const serviceGetSubcategoriesByIDsCategoriesForAssignDishes = (
	args: IGetSubcategoriesByIDsCategoriesArguments,
): Promise<IGetSubcategoriesByIDsCategoriesForAssignDishes> => {
	const dataForRequest = {
		categoryIds: args.categoryIds,
	};
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/AssignDishes/restaurants/${args.restaurantId}/categories`,
		data: dataForRequest,
	});
};
// Menu v1
// Menu v2
const serviceGetSubcategoriesByIDsCategoriesForAssignDishesV2 = (
	args: IGetSubcategoriesByIDsCategoriesArguments,
): Promise<IGetSubcategoriesByIDsCategoriesForAssignDishes> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v2/assign-dishes/restaurants/${args.restaurantId}/categories`,
		data: args,
	});
};
// Menu v2

// Menu v1
const serviceGetDishesByIDsSubcategoriesForAssignDishes = (
	args: IGetDishesByIDsSubcategoriesArguments,
): Promise<IGetDishesByIDsSubcategoriesForAssignDishes> => {
	const dataForRequest = {
		subCategoryIds: args.subCategoryIds,
	};
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/AssignDishes/restaurants/${args.restaurantId}/subcategories`,
		data: dataForRequest,
	});
};
// Menu v1
// Menu v2
const serviceGetDishesByIDsSubcategoriesForAssignDishesV2 = (
	args: IGetDishesByIDsSubcategoriesArguments,
): Promise<IGetDishesByIDsSubcategoriesForAssignDishes> => {
	return request({
		typeOfRequest: 'postWithToken',
		url: `/api/v2/assign-dishes/restaurants/${args.restaurantId}/subcategories`,
		data: args,
	});
};
// Menu v2

// Menu v1
const serviceAssignDish = (data: IAssignDish): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/AssignDishes`, data });
};
// Menu v1
// Menu v2
const serviceAssignDishV2 = (data: IAssignDish): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/assign-dishes`, data });
};
// Menu v2

const serviceAssignDishToSubcategories = (data: IAssignDishToSubcategories): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/dishes/${data.dishId}/assignment`, data });
};

const serviceAssignDishToSubcategoriesValidate = (
	data: IAssignDishToSubcategories,
): Promise<IAssignDishToSubcategoriesValidate> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/dishes/${data.dishId}/assignment:validate`, data });
};

const serviceUpdateRestaurantsInDish = (data: {
	dishId: string;
	restaurantIds: string[];
}): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/dishes:update-restaurants`, data });
};

const serviceGetDishPortionInfo = (portionId: string): Promise<IGetDishPortionInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/v2/dishes/portions/${portionId}` });
};

const serviceCreatePortion = (data: ICreatePortion): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: '/api/v2/portions', data });
};

const serviceGetDishRestaurantPortions = (
	args: IGetDishRestaurantPortionsArguments,
): Promise<IGetDishRestaurantPortions> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/dishes/${args.dishId}/portions`,
	});
};

const serviceToggleDishPortionsEnabled = (data: IToggleDishPortionsEnabledArguments): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/dishes/${data.dishId}/portion-enabled`, data });
};

const serviceDeletePortion = (args: IDeleteDishPortionArguments): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/v2/portions/${args.portionId}?restaurantId=${args.restaurantId}`,
	});
};

const serviceUpdatePortion = (data: IUpdatePortion): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/portions/${data.portionId}`, data });
};

const serviceGetPortionPositionList = (args: IGetPortionPositionListArguments): Promise<IGetPortionPositionList> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/dishes/${args.dishId}/portions`,
	});
};

const serviceGetPortionPositionChains = (
	args: IGetPortionPositionListArguments,
): Promise<IGetPortionPositionChains> => {
	return request({
		typeOfRequest: 'getWithToken',
		url: `/api/v2/restaurants/${args.restaurantId}/dishes/${args.dishId}/restaurants-with-same-portions`,
	});
};

const serviceUpdatePortionPositions = (data: IUpdatePortionPositions): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/v2/portions:change-positions`, data });
};

const serviceGetDishPhotos = (args: {
	ids: string[];
	size: 1 | 2 | 3;
}): Promise<
	AxiosResponse<{
		files: {
			id: string;
			preSignedUrl: Nullable<string>;
		}[];
	}>
> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/v2/dish-photos:search`, data: args });
};

export {
	serviceGetDishInfo,
	serviceGetDishInfoV2,
	serviceGetDishesShortBySubCategoryId,
	serviceGetDishesShortBySubCategoryIdV2,
	serviceGetDishesShortBySubCategoryIds,
	serviceGetDishesShortByCustomerId,
	serviceGetDishesShortByRestaurantId,
	serviceGetDishesByRestaurantIdsAndSubcategoryIds,
	serviceCreateDish,
	serviceCreateDishV2,
	serviceUpdateDish,
	serviceUpdateDishV2,
	serviceGetPaginatedDishes,
	serviceGetPaginatedDishesByCustomerV2,
	serviceGetPaginatedDishesByRestaurantV2,
	serviceDeleteDish,
	serviceDeleteDishV2,
	serviceGetDishPositionList,
	serviceGetDishPositionListV2,
	serviceGetDishPositionsChains,
	serviceGetDishPositionsChainsV2,
	serviceUpdateDishPositions,
	serviceUpdateDishPositionsV2,
	serviceGetDishRestaurantProperties,
	serviceUpdateDishRestaurantProperties,
	serviceUpdateDishRestaurantPropertiesAsPatch,
	serviceGetPaginatedDishesForAssign,
	serviceGetPaginatedDishesForAssignV2,
	serviceGetListRestaurantsForAssignDishes,
	serviceGetListRestaurantsForAssignDishesV2,
	serviceGetCategoriesByIDRestaurantForAssignDishes,
	serviceGetCategoriesByIDRestaurantForAssignDishesV2,
	serviceGetSubcategoriesByIDsCategoriesForAssignDishes,
	serviceGetSubcategoriesByIDsCategoriesForAssignDishesV2,
	serviceGetDishesByIDsSubcategoriesForAssignDishes,
	serviceGetDishesByIDsSubcategoriesForAssignDishesV2,
	serviceAssignDish,
	serviceAssignDishV2,
	serviceAssignDishToSubcategories,
	serviceAssignDishToSubcategoriesValidate,
	serviceUpdateRestaurantsInDish,
	serviceGetDishPortionInfo,
	serviceCreatePortion,
	serviceGetDishRestaurantPortions,
	serviceToggleDishPortionsEnabled,
	serviceDeletePortion,
	serviceUpdatePortion,
	serviceGetPortionPositionList,
	serviceGetPortionPositionChains,
	serviceUpdatePortionPositions,
	serviceGetDishPhotos,
};
